import { createContext } from 'react';

const CoreToggleContext = createContext({});

export default CoreToggleContext;
